import { defaultLanguage } from '../../consts';

export const mapStoryblokLang = (lang: string): string => {
  if (lang === 'default') return defaultLanguage;
  return lang;
};
